<div class="px-5 py-10">
    <form
        class="flex flex-col"
        [formGroup]="form">
        <mat-form-field>
            <mat-label>Name</mat-label>
            <input
                matInput
                formControlName="name" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Trigger type</mat-label>
            <mat-select formControlName="triggerType">
                @for (keyValue of QuestTriggerType | appEnumKeyValue; track $index) {
                    <mat-option [value]="keyValue.value">{{ keyValue.key }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        @if (form.controls.triggerType.value === QuestTriggerType.Schedule) {
            <mat-form-field>
                <mat-label>Schedule</mat-label>
                <mat-select formControlName="scheduleId">
                    @for (schedule of schedulesStore.entities(); track $index) {
                        <mat-option [value]="schedule.id">{{ schedule.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        <div
            class="flex flex-col"
            formGroupName="condition">
            <mat-form-field>
                <mat-label>Condition type</mat-label>
                <mat-select formControlName="conditionType">
                    @for (keyValue of QuestConditionType | appEnumKeyValue; track $index) {
                        <mat-option [value]="keyValue.value">{{ keyValue.key }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @let conditionType = form.controls.condition.controls.conditionType.value;
            @if(conditionType === QuestConditionType.Purchase) {
                <mat-form-field>
                    <mat-label>Amount</mat-label>
                    <input
                        matInput
                        type="number"
                        noScroll
                        min="0"
                        formControlName="amount" />
                </mat-form-field>
            }
            @if(conditionType === QuestConditionType.InviteFriend ||
                conditionType === QuestConditionType.Install ||
                conditionType === QuestConditionType.Purchase ||
                conditionType === QuestConditionType.CompleteGoals ||
                conditionType === QuestConditionType.CompleteQuests) {
                <mat-form-field>
                    <mat-label>Count</mat-label>
                    <input
                        matInput
                        type="number"
                        noScroll
                        min="0"
                        formControlName="count" />
                </mat-form-field>
            }
            @if(conditionType === QuestConditionType.CompleteGoals) {
                <mat-form-field>
                    <mat-label>Goal ids</mat-label>
                    <mat-chip-grid
                        #grid
                        formControlName="goalIds">
                        @for (day of goalIdsControl.value; track $index) {
                            <mat-chip-row (removed)="removeGoalId(day)">
                                {{ day }}
                                <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                        }
                    </mat-chip-grid>
                    <input
                        placeholder="Goal ids"
                        [matChipInputFor]="grid"
                        (matChipInputTokenEnd)="addGoalId($event)" />
                </mat-form-field>
            }
        </div>
        <mat-form-field>
            <mat-label>Offer</mat-label>
            <mat-select formControlName="offerId">
                @for (offer of offers(); track $index) {
                    <mat-option [value]="offer.id">
                        {{ offer.affiseOfferId }} - {{ offer.title }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Cash reward</mat-label>
            <input
                matInput
                type="number"
                noScroll
                min="0"
                formControlName="moneyReward" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Exp reward</mat-label>
            <input
                matInput
                type="number"
                noScroll
                min="0"
                formControlName="expReward" />
        </mat-form-field>
    </form>
    <button
        mat-flat-button
        color="primary"
        [disabled]="form.invalid"
        (click)="createOrUpdateTemplate()">
        Save
    </button>
</div>
